import { ColDef, ColGroupDef } from "ag-grid-enterprise";

export const useBilletsYardTableData = () => {
  const columns: ColGroupDef[] = [
    {
      headerName: "Billets Yard",
      children: [
        {
          field: "Molds",
          headerName: "Section",
          flex: 1,
        },
        {
          field: "Length",
          headerName: "Length",
          flex: 1,
        },
        {
          field: "Quality",
          headerName: "Quality",
          flex: 1,
          valueGetter: (params) => {
            return params.data.Quality === "G"
              ? "Good"
              : params.data.Quality === "U"
                ? "Unidentified"
                : params.data.Quality === "S"
                  ? "Scrapped"
                  : "";
          },
        },
        {
          field: "BilletCount",
          headerName: "Billets Count",
          flex: 1,
        },
      ],
    },
  ];

  const defaultColDef: ColDef = {
    filter: false,
    floatingFilter: false,
    sortable: false,
    resizable: false,
    editable: false,
  };

  return { columns, defaultColDef };
};
